import ReactDOM from 'react-dom';
import { randomString } from 'sma.common/utils';
import { Option } from 'sma.fs/surveys/options';
import * as modals from 'sma.common/components/modals';
import ajax from "../../../sma.common/ajax";

const Class = require('sma.fs/chide/class');
const chide = require('sma.fs/chide/ui');

const Fields = {};

Fields.Actions = {
	copy: {
		action:'copy',
		cls: 'btn-default',
		displayName: gettext('Copy'),
		toolTip: gettext('Copy'),
		groupAction: true,
		groupOnlyAction: false,
		inToolbox: false,
		inContextMenu: () => { return true; },
		handler: function (fields, e, callback, keepBranching) {
			if (!fields) {
				return;
			}
			if (!fields.length) {
				fields = [fields];
			}
			let editor = require('sma.fs/surveys/editor').Editor.instances[0];
			let field;
			let copied = [];
			for (let i = fields.length-1; i >= 0; i--){
				field = $(fields[i]).firstAttached(Fields.Field).serialize();
				field.name = '';
				if (!keepBranching) {
					Fields.Helpers.removeBranching(field);
				}
				copied.push(field);
			}
			$.ajax({
				url: editor.clipboardUrl + '?c=' + randomString(10),
				data: {
					clipboard: JSON.stringify(copied)
				},
				block: false,
				dataType: 'json',
				type: 'post',
				success: function (_data) {
					if (callback && typeof(callback) == typeof(function (){})) {
						callback(true);
					}
				},
				error: function (_data) {
					if (callback && typeof(callback) == typeof(function (){})) {
						callback(false);
					}
				}
			});
		}
	},
	cut: {
		action:'cut',
		cls: 'btn-default',
		displayName: gettext('Cut'),
		toolTip: gettext('Cut'),
		groupAction: true,
		groupOnlyAction: false,
		inToolbox: false,
		inContextMenu: () => { return true; },
		handler: function (fields, e){
			Fields.Actions.copy.handler(fields, e, function (success) {
				if (success) {
					let editor = require('sma.fs/surveys/editor').Editor.instances[0];
					editor.survey.removeFields(fields);
					editor.fieldsSelected(undefined, e);
				}
			}, true);
		}
	},
	paste: {
		cls: 'btn-default',
		action: 'paste',
		displayName: gettext('Paste'),
		toolTip: gettext('Paste'),
		groupAction: true,
		groupOnlyAction: false,
		inToolbox: false,
		inContextMenu: () => { return true; },
		handler: function (fields, e, _click) {
			const editor = require('sma.fs/surveys/editor').Editor.instances[0];
			let target = -1;
			if (!fields || !fields.length) {
				const clickTop = parseInt(editor.fieldContextMenu.container.css('top'), 10);
				_.each(editor.survey.currentPage.fields, function (el, i) {
					if ((el.element.offset().top + el.element.height()) <= clickTop) {
						target = i;
					}
				});
			}

			$.ajax({
				type: 'get',
				url: editor.clipboardUrl,
				data: { c: randomString(10) },
				block: false,
				success: function (data) {
					if (!data.success || !data.clipboard) {
						return;
					}
					const clipboard = data.clipboard;
					let fieldInfo;
					const duplicates = [];
					for (let i = 0; i < clipboard.length; i++) {
						fieldInfo = $.extend(true, {}, clipboard[i]);
						fieldInfo.id = randomString(10);
						if (fieldInfo.children && fieldInfo.children.length && fieldInfo.children[0].looping) {
							delete fieldInfo.children[0]['looping'];
						}

						duplicates.push(editor.addField(
							undefined,
							fieldInfo,
							undefined,
							(fields && fields.length) ? fields[fields.length - 1] : target
						).element);
					}

					$(duplicates).each(function () {
						Fields.Helpers.normalizeField($(this).firstAttached(Fields.Field));
					});

					editor.fieldsSelected(duplicates, e);
				}
			});
		}
	},
	del_field: {
		cls: 'btn-danger',
		action:'del_field',
		className: 'separator',
		displayName: gettext('Delete'),
		toolTip: gettext('Delete'),
		groupAction: true,
		groupOnlyAction: false,
		inToolbox: false,
		formatIdList(ids) {
			let result = '';
			ids.forEach(function (value, index){
				if (index <= 2){
					result += value + ', ';
				} else {
					result += '...';
				}
			});
			return result;
		},
		inContextMenu: () => { return true; },
		handler: function (fields, e, _skipPrompt) {
			fields = $.makeArray(fields);

			if (!fields.length) {
				return;
			}

			let modalTitle = gettext('Delete Fields');
			let modalBody = gettext('Are you sure you want to delete the selected fields? This cannot be undone.');
			// const firstField = fields[0];

			const editor = _.last(require('sma.fs/surveys/editor').Editor.instances);
			// const warningHTML = '<br/><i class="nc-icon-mini ui-3_alert sma-danger-icon mr-1"></i>';

			if (fields.length == 1 && fields[0].attributes.name.nodeValue == 'section-separator') {
				modalTitle = gettext('Delete section heading');
				modalBody = gettext('Are you sure you want to delete this section heading?');
				new modals.Confirm(
					modalTitle, modalBody,
					() => {
						editor.survey.removeFields(fields);
						editor.fieldsSelected(undefined, e);
					}, {
						destroyOnClose: true,
						yes: gettext('Delete'),
						no: gettext('Cancel'),
						yes_class: 'btn-danger',
						no_class: 'btn-white'
					}
				);
			} else {
				var id = editor.survey.getFieldArray(fields)[0].id;
				// call api check if field is being used

				let options = {
				url: reverse('surveys-question-check'),
				data: {
					field_id: id,
					survey_id: editor.surveyID
				},
				callback: response => {
					if (response.result.can_delete){
						new modals.CheckboxModal(
							gettext('Delete form question', 'Delete form questions', fields.length),
							gettext(
								'Deleting this question from this form will also delete any associated data that has been collected from users of this form.',
								'Deleting these questions from this form will also delete any associated data that has been collected from users of this form.',
								fields.length
							),
							gettext(
								'Yes, I understand that upon saving this form this question and any associated data will be permanently deleted and that this action cannot be undone.',
								'Yes, I understand that upon saving this form these questions and any associated data will be permanently deleted and that this action cannot be undone.',
								fields.length
							),
							() => {
								editor.survey.removeFields(fields);
								editor.fieldsSelected(undefined, e);
							},
							{
								destroyOnClose: true,
								contingent: true,
								isDelete: true
							}
						);
					} else {
						let title = gettext('Question not removable');
						let desc = gettext('This question is being actively used. ' +
							'Please update any and all of these areas before deleting this question.'
						);

						if (response.result.triggers.length > 0){
							let result = '';
							response.result.triggers.forEach((id) => {
							    const url = reverse('admin-awards-triggers-edit', { trigger_id: id, award_id: sma_award_id });
								result += `<a class="id_link" href="${url}" target="_blank">${id}</a> `;
							});
							desc += "<br>"
							desc += "<br> Automation id(s): " +  result;
						}
						new modals.Notify(title, desc, gettext('Ok'), () => {});
						return;
					}
				}
			}
				ajax.get(options);
			}
		}
	},
	move_field: {
		cls: 'btn-default',
		action:'move_field',
		className: '',
		displayName: gettext('Move To'),
		toolTip: gettext('Click here to move the selected questions to another page'),
		groupAction: true,
		groupOnlyAction: false,
		inToolbox: false,
		inContextMenu: () => { return true; },
		handler: function (fields, e){
			if (!fields) {
				return;
			}
			if (!fields.length) {
				fields = [fields];
			}
			let editor = require('sma.fs/surveys/editor').Editor.instances[0];
			let survey = editor.survey;

			let pageSelector = $('<select class="custom-select" id="moveToPage"><\/select>');

			$.each(editor.survey.pages, function (i) {
				if (this !== survey.currentPage) {
					var label = editor.languages.translate(this.label.value, editor.languages.selected());
					if (!label) {
						label = gettext('Page') + ' ' + (this.index + 1);
					} else{
						label = gettext('Page') + ' ' + (this.index + 1) + " - " + label;
					}
					pageSelector.addOption(this.id, label, false);
				}
			});

			let dialogContent = $('<div class="move-to-page">' + gettext('Move the selected questions to: ') + '<\/div>')
				.append(pageSelector);

			let dialog = new modals.ContentModal(dialogContent, {
				title:gettext('Move Question'),
				destroyOnClose: true,
				buttons: [{
					'cls': 'btn-default',
					'label': 'Move',
					handler: () => {
						// Unmount potential react components
						let element = $('#survey-editor-field-options');
						ReactDOM.unmountComponentAtNode(element[0]);
						// Move the field to another page
						let page = survey.pageMapping[pageSelector.selectedValues()[0]];
						survey.moveFields(fields, page);
						survey.switchPage(page.index);
						editor.fieldsSelected(fields, e);
						// Hide dialog.
						dialog.destroy();
					}
				}]
			});
			dialog.show();
		}
	},
	duplicate: {
		cls: 'btn-default',
		action:'duplicate',
		className: '',
		displayName: gettext('Duplicate'),
		toolTip: gettext('Duplicate'),
		groupAction: true,
		groupOnlyAction: false,
		inToolbox: false,
		inContextMenu: () => { return true; },
		handler: function (fields, e) {
			if (!fields) {
				return;
			}
			if (!fields.length) {
				fields = [fields];
			}

			let editor;
			if (fields[0].editor) {
				editor = fields[0].editor;
			} else {
				editor = $(fields[0]).firstAttached(Fields.Field).editor;
			}

			let fieldInfo;
			let duplicates = [];
			for (let i = fields.length-1; i >= 0; i--){
				if (!fields[i].editor){
					fieldInfo = $.extend(true, {}, $(fields[i]).firstAttached(Fields.Field).serialize());
				} else {
					fieldInfo = $.extend(true, {}, fields[i].serialize());
				}

				fieldInfo.id = randomString(10);
				fieldInfo.name = '';

				if (fieldInfo.children && fieldInfo.children.length && fieldInfo.children[0].looping){
					delete fieldInfo.children[0]['looping'];
				}

				duplicates.push(editor.addField(undefined, fieldInfo, undefined, fields[fields.length-1]).element);
			}
			try {
				editor.fieldsSelected(duplicates, e);
			} catch(e) {
				// Do nothing
			}
		}
	},
	edit_rules: {
		cls: 'btn-default',
		action:'edit_rules',
		className: '',
		displayName: gettext('Edit Rules'),
		toolTip: gettext('Edit Rules'),
		groupAction: false,
		groupOnlyAction: false,
		inToolbox: false,
		inContextMenu: () => { return false; },
		handler: null
	},
	mark_optional: {
		cls: 'btn-default',
		action:'mark_optional',
		className: '',
		displayName: gettext('Mark all as optional'),
		toolTip: gettext('Mark all as optional'),
		groupAction: true,
		groupOnlyAction: false,
		inToolbox: false,
		inContextMenu: () => { return true; },
		handler: function (fields, _e){
			if (!fields) {
				return;
			}
			if (!fields.length) {
				fields = [fields];
			}
			$(fields).each(function (_i){
				let obj = $(this).firstAttached(Fields.Field);
				if (obj.optional) {
					obj.optional.set(true);
					obj.optional.refresh();
				} else if (obj.rows) {
					_.each(obj.rows.value, function (el){
						el.optional.set(true);
						el.optional.refresh();
					});
				} else if (obj.variables) {
					_.each(obj.variables.value, function (el){
						el.optional.set(true);
						el.optional.refresh();
					});
				}
			});
		}
	},
	mark_unoptional: {
		cls: 'btn-default',
		action:'mark_unoptional',
		className: '',
		displayName: gettext('Mark all as required'),
		toolTip: gettext('Mark all as required'),
		groupAction: true,
		groupOnlyAction: false,
		inToolbox: false,
		inContextMenu: () => { return true; },
		handler: function (fields, _e){
			if (!fields) {
				return;
			}
			if (!fields.length) {
				fields = [fields];
			}
			$(fields).each(function (_i){
				let obj = $(this).firstAttached(Fields.Field);
				if (obj.optional) {
					obj.optional.set(false);
					obj.optional.refresh();
				} else if (obj.rows) {
					_.each(obj.rows.value, function (el){
						el.optional.set(false);
						el.optional.refresh();
					});
				} else if (obj.variables) {
					_.each(obj.variables.value, function (el){
						el.optional.set(false);
						el.optional.refresh();
					});
				}
			});
		}
	},
	looping: {
		cls: 'btn-default',
		action: 'looping',
		className: 'separator',
		displayName: gettext('Looping'),
		toolTip: gettext('Looping'),
		groupAction: false,
		groupOnlyAction: false,
		inToolbox: false,
		inContextMenu: () => { return true; },
		handler: function (fields, _e) {
			// let editor = require('sma.fs/surveys/editor').Editor.instances[0];

			const field = $(fields[0]).firstAttached(Fields.Field);
			if (field.survey.looping.pageIsLooped(field.page)) {
				alert(gettext('We\'re sorry, looping within a loop is not currently supported.'));
			} else {
				field.editor.survey.looping.showForQuestion(field);
			}
		}
	},
	intersection: function (fields) {
		if (!fields || (!fields.length && !fields.supportedActions)) {
			return [];
		}
		if (fields.length === 1) {
			fields = fields[0];
		}
		if (fields.supportedActions) {
			return $.grep(fields.supportedActions, function (el, _i) {
				return el && el.groupOnlyAction === false;
			});
		}
		return $.grep(Array.intersection($.map(fields, function (el) {
			return el.supportedActions;
		})), function (el, _i) {
			return (el && el.groupAction === true);
		});
	}
};

Fields.Field = $.klass({
	type: undefined,
	qlass: undefined,
	cssType: undefined,

	displayName: 'Field',
	helpText: '',
	isVisible: true,
	isEnabled: true,

	isQuestion: true,
	isGrouped: false,
	isCustom: false,
	isDynamic: false, // Determines whether children can be disabled via branching
	isBranchable: false,

	isScorable: false,
	hasScores: false,

	extractable: false,

	supportedActions: [
		Fields.Actions.cut,
		Fields.Actions.copy,
		Fields.Actions.paste,
		Fields.Actions.del_field,
		Fields.Actions.move_field,
		Fields.Actions.duplicate,
		Fields.Actions.edit_rules,
		Fields.Actions.mark_optional,
		Fields.Actions.mark_unoptional
	],

	options: {
		displayInline: Class.create(chide.opts.Checkbox, {
			label: gettext('Display side-by-side'),
			help: gettext("Display side-by-side - In order for two questions to display side-by-side, you'll have to enable this option for both questions. The first question will be on the left and the second on the right."),
			changed: function (value) {
				this.field.element.toggleClass('field-inline', value);
				this.field.survey.resizeSideBySide();
			}
		}),

		appendToPrevious: Class.create(chide.opts.Checkbox, {
			label: gettext('Append to previous question'),
			help: gettext("Append to previous question - Use this to make this question appear as if it's part of the previous question. This is great for adding a comment box to the previous question.")
		}),

		width: Class.create(chide.opts.Number, {
			label: gettext('Width'),
			inputClass: 'text inline medium',
			help: gettext('Question Width - Percentage of the survey width that this question will take up. (This will not be reflected in the editor)'),
			applyEdit: false,
			min: 0,
			max: 200,
			changed: function (value) {
				if (value > 0 && value <= 200) {
					this.field.element.width(value + '%').width(this.field.element.width()-22);
				} else {
					this.field.element.width('auto');
					this.set(100);
				}
			}

		}),

		optional: Class.create(chide.opts.Checkbox, {
			label: gettext('Optional'),
			fromInfo: function (info) {
				if (info && info.required !== undefined) {
					return !info.required;
				}
				if (info && info.children && info.children.length) {
					return (info.children[0].required !== undefined)? !info.children[0].required : false;
				}
				return false;
			}
		})
	},

	initialize: function (info, editor) {
		const that = this;

		info = info || {};

		this.info = info;
		this.editor = editor;
		this.survey = editor.survey;

		let id = randomString(10);
		let name;

		if (info.name && !info.id) {
			// old survey
			id = info.name;
			name = undefined;
		} else if (info.id) {
			id = info.id;
			name = info.name;
		} else if (info.children && info.children[0]) {
			// old survey
			if (info.children[0].name && !info.children[0].id) {
				id = info.children[0].name;
				name = undefined;
			} else if (info.children[0].id) {
				id = info.children[0].id;
				name = info.children[0].name;
			}
		}

		this.id = id;

		this.name = new (Class.create(chide.opts.Text, {
			label: gettext('Identifier'),
			help: gettext('Identifier - (e.g., \'question1\') Identifiers are used ' +
				'to refer to questions when programming advanced logic conditions.'),
			applyEdit: true,
			translatable: false,
			blankText: function () {
				return gettext('None');
			},
			changed: function (value, old) {
				const it = this;
				const error = function (errorMessage, old) {
					alert(errorMessage);
					it.set(old);
				};

				if (value in that.survey.nameMapping && that.survey.nameMapping[value] !== that) {
					error(gettext('Question identifiers must be unique.'), old);
					return;
				}

				if (!/^[a-zA-Z][A-Za-z0-9_]*$/.test(value)) {
					error(gettext('Question identifiers must begin with a letter, ' +
						'and may only contain letters, numbers, and underscores.'), old);
					return;
				}

				if (value === 'length') {
					error(gettext('\'length\' is a reserved keyword. Enter another identifier.'), old);
					return;
				}

				if (old) {
					$('ol.page.active').trigger('childChanged', [old, value]);
					delete that.survey.nameMapping[old];
				}

				if (value) {
					that.survey.nameMapping[value] = that;
				} else {
					delete that.survey.nameMapping[value];
				}

				if (value !== undefined) {
					$('span.name', that.element).html(value);
				} else {
					$('span.name', that.element).html('');
				}
			}
		}))({
			value: (name === undefined) ? '' : name
		});

		if (name) {
			this.survey.nameMapping[name] = this;
		}

		this.title = new (Class.create(chide.opts.Html, {
			label: gettext('Title'),
			changed: function (value) {
				let title = value + (that.optional && that.optional.get() ?
					` <small>${gettext('(optional)')}</small>` : '');
				$('.title', that.element).html(that.survey.stripScriptTags(_.unescape(title)));
			}
		}))({
			value:
				(that.type != 'section-separator') ?
					(that.type != 'javascript') ?
						(info.title || (gettext('Question') + ' ' + (this.survey.getFieldCount() + 1)))
						: (info.title || gettext('JavaScript'))
					: (info.title || gettext('Section Heading'))
		});

		this.description = new (Class.create(chide.opts.Html, {
			label: gettext('Description'),
			changed: function (value) {
				$('.description', that.element).html(that.survey.stripScriptTags(_.unescape(value)));
				that.survey.renderVideoElements()
			}
		}))({
			value: info.description || ''
		});

		this.displayInline = new this.options.displayInline({
			value: (info.display_inline !== undefined) ? !!info.display_inline : false,
			field: this
		});

		this.widthOption = new this.options.width({ value: info.width || 100, field: this });

		this.appendToPrevious = new this.options.appendToPrevious({
			value: info.appendToPrevious || false
		});

		this.page = $('ol.page.active').length - 1;

		const looping = info && info.looping ||
			info.children && info.children[0] && info.children[0].looping ||
			undefined;

		if (looping) {
			this.survey.looping.addLoopRule(this.id, looping);
		}

		/* hack so that firstAttached will return the field attached to an element */
		if (!Fields.Field.instances) {
			Fields.Field.instances = [];
		}
		Fields.Field.instances.push(this);
	},

	showOptions: function (options, clearOnly) {
		// Clear options and add new set of options
		// Remove React component (support for new react fields)
		const element = options[0];
		ReactDOM.unmountComponentAtNode(element);
		// Clear non-react components
		options.html('');
		if (!clearOnly) {
			options.append(
				Option.renderGroup(gettext('General'), [
					this.name.render(),
					this.title.render(),
					this.description.render()
				], false));
		}
	},

	serialize: function () {
		let loops = this.survey.looping.loops;

		return $.extend({
			type: 'question',
			id: this.id,
			idname: this.qlass,
			title: this.title.value,
			description: this.description.value
		}, {
			display_inline: this.displayInline.get() || undefined,
			width: this.widthOption.get() || undefined,
			appendToPrevious: this.appendToPrevious.get() || undefined,
			name: this.name.value || undefined,
			looping: this.id in loops && loops[this.id].serialize() || undefined
		});
	},

	getIdentifier: function (labeled, limit) {
		labeled = (labeled === undefined) ? true : !!labeled;
		limit = (limit === undefined) ? 60 : (limit <= 0) ? undefined : limit;

		let name = this.name.get();

		if (!labeled) {
			return name;
		}

		let id = (name) ? '[' + name + '] ' + this.title.get() : this.title.get();

		id = $($('<div/>').append(id)).text();

		return (id.length > limit) ? id.substring(0, limit - 3) + '...' : id;
	},

	getVariables: function () {
		return [];
	},

	formatInfo: function () {
		return {
			type: this.type,
			id: this.id,
			title: this.title.get(),
			label: this.getIdentifier(true, 60),
			vars: $.map(this.getVariables(), function (el) { return el.id; })
		};
	},

	renderContent: function () { },

	render: function () {
		// Clear the element
		this.element.empty();

		// Build new element
		const that = this;
		const inlineFieldOptions = $('<div class="sma-js-field-actions"></div>');

		if (that.supportedActions.indexOf(Fields.Actions.looping) > -1) {
			inlineFieldOptions.append(
				$('<a href="#" class="nc-icon-mini arrows-1_loop-82 looping"' +
				`title=${gettext('Looping')}></a>`).tooltip()
			);
		}

		inlineFieldOptions
			.append($(`<a data-variable-name="${this.id}"></a>`))
			.append($('<a href="#" class="nc-icon-mini gestures_drag-31 move"' +
				`title="${gettext('Move')}"></a>`).tooltip())
			.append($('<a href="#" class="nc-icon-mini files_single-copy-04 duplicate"' +
				`title="${gettext('Duplicate')}"></a>`).tooltip())
			.append($('<a href="#" class="nc-icon-mini ui-1_trash-simple remove"' +
				`title="${gettext('Delete')}"></a>`).tooltip())
			.toggleClass('rtl', this.editor.languages.selected() === 'ar' || this.editor.languages.selected() === 'fa');

		this.element.append(inlineFieldOptions);
		this.element.toggleClass('field-inline', this.displayInline.get());
		const newWidth = parseFloat(this.widthOption.get() || 100);

		if (newWidth < 90) {
			this.element.width(newWidth + '%');
		}

		let optionalText = '';
		if (this.optional !== undefined && this.optional.get()) {
			optionalText = `<small>${gettext('(optional)')}</small>`;
		}

		this.element.append(
			'<span class="status"></span>',
			`<span class="label label-primary name">${((that.name.get()) ? that.name.get() : '')}</span>`,
			`<span class="title fr-view">${_.unescape(that.title.get())} ${optionalText}</span>`,
			'<h7 class="sma-question-has-score">(Scored)</h7>',
			`<div class="description fr-view">${_.unescape(that.description.get())}</div>`
		);

		this.renderContent();
	}
});

export default Fields;
